import { render, staticRenderFns } from "./LiberarRepasseDialog.vue?vue&type=template&id=3046a420&"
import script from "./LiberarRepasseDialog.vue?vue&type=script&lang=js&"
export * from "./LiberarRepasseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports